import { Accordion } from 'react-bootstrap'
import { Zoom } from 'react-awesome-reveal'
import '../../styles/Utils/AccordionItem.css'

function AccordionItem({ indexKey, header, body }) {

    return (

        <Zoom triggerOnce={true} delay={(indexKey) * 50} duration={500}>
            <Accordion.Item eventKey={indexKey}>
                <Accordion.Header>
                    {header}
                </Accordion.Header>
                <Accordion.Body>
                    {body}
                </Accordion.Body>
            </Accordion.Item>
        </Zoom>

    )

}

export default AccordionItem